import React from "react"
import {
    Card,
    CardBody,
} from "reactstrap";
import moment from "moment";

class Attorney extends React.Component {

    render() {
        
        const {
            client
        } = this.props;

        return (
            <Card>
                <CardBody>
                  <div className="typography-line">
                    <h4>
                      <span>First Name</span>
                      {client.attorney.first_name || "N/A"}
                    </h4>
                  </div>
                  <div className="typography-line">
                    <h4>
                      <span>Last Name</span>
                      {client.attorney.last_name || "N/A"}
                    </h4>
                  </div>
                  <div className="typography-line">
                    <h4>
                      <span>Middle Name</span>
                      {client.attorney.middle_name || "N/A"}
                    </h4>
                  </div>
                  <div className="typography-line">
                    <h4>
                      <span>Gender</span>
                      {client.attorney.gender || "N/A"}
                    </h4>
                  </div>
                  <div className="typography-line">
                    <h4>
                      <span>Birthday</span>
                      {client.attorney.birthday
                        ? moment(client.birthday).format(
                            "MM/DD/YYYY"
                          )
                        : "N/A"}
                    </h4>
                  </div>
                  <div className="typography-line">
                    <h4>
                      <span>Age</span>
                      {client.attorney.age || "N/A"}
                    </h4>
                  </div>
                  <div className="typography-line">
                    <h4>
                      <span>Nationality</span>
                      {client.attorney.nationality || "N/A"}
                    </h4>
                  </div>
                  <div className="typography-line">
                    <h4>
                      <span>Email</span>
                      {client.attorney.email || "N/A"}
                    </h4>
                  </div>
                  <div className="typography-line">
                    <h4>
                      <span>Phone</span>
                      {client.attorney.phone || "N/A"}
                    </h4>
                  </div>
                  <div className="typography-line">
                    <h4>
                      <span>Address</span>
                      {client.attorney.address || "N/A"}
                    </h4>
                  </div>
                </CardBody>
            </Card>
        )
    }
}

export default Attorney;